/**
 * gets computed document direction
 */
export default (function () {
  return typeof window !== 'undefined' && window.getComputedStyle(document.body).direction === 'rtl';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/utils/directionUtil.js
// module id = 2932
// module chunks = 31